import TurndownService from 'turndown'

const HTML_RE = /<\/?[a-z][\s\S]*>/i

const getTurndown = () => {
  const service = new TurndownService({
    headingStyle: 'atx',
    bulletListMarker: '-',
    codeBlockStyle: 'fenced'
  })
  service.keep(['table', 'thead', 'tbody', 'tr', 'th', 'td'])
  return service
}

let turndownInstance = null

export const looksLikeHtml = (value) => HTML_RE.test(String(value || ''))

export const htmlToMarkdown = (html) => {
  const input = String(html || '')
  if (!input) return ''
  if (!turndownInstance) turndownInstance = getTurndown()
  return turndownInstance.turndown(input)
}

export const normalizeDescriptionToMarkdown = (value) => {
  if (value == null) return value
  if (Array.isArray(value)) {
    return value
      .map((entry) => normalizeDescriptionToMarkdown(entry))
      .filter(Boolean)
      .join('\n\n')
  }
  if (typeof value !== 'string') return value
  if (looksLikeHtml(value)) return htmlToMarkdown(value)
  return value
}

export const normalizeDescriptionToMarkdownText = (value) => {
  if (value == null) return ''
  if (Array.isArray(value)) {
    return value
      .map((entry) => normalizeDescriptionToMarkdownText(entry))
      .filter(Boolean)
      .join('\n\n')
  }
  if (typeof value !== 'string') return String(value)
  return looksLikeHtml(value) ? htmlToMarkdown(value) : value
}
